import { render, staticRenderFns } from "./programsTable.vue?vue&type=template&id=357a23ec&"
import script from "./programsTable.vue?vue&type=script&lang=ts&"
export * from "./programsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports